// removed by extract-text-webpack-plugin
module.exports = {"monthly":"monthly","fa-lg":"fa-lg"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/MonthlyFinance/monthly.scss
// module id = 7Rn2
// module chunks = 0